import { getNewsFeed } from "@/common/service/newsFeedService";

export default {
  namespaced: true,

  // initial state
  state: {
    newsFeed: []
  },

  //mutations
  mutations: {
    setNewsFeed(state, newsFeed) {
      state.newsFeed = newsFeed;
    }
  },

  //actions
  actions: {
    async loadNewsFeed({ commit, dispatch }) {
      dispatch("error/setError", null, { root: true });
      try {
        const newsFeed = await getNewsFeed();
        commit("setNewsFeed", newsFeed);
      } catch (error) {
        dispatch("error/setError", error, { root: true });
      }
    }
  },

  //getters
  getters: {
    newsFeed: state => state.newsFeed.news
  }
};
